import { Customer } from '../types/customer';

/**
 * Megjelenítendő ügyfélnév.
 * Az importált adatokban gyakran ugyanaz a vezeték- és keresztnév (mindkettő a cégnév),
 * vagy a név duplán szerepel – ezeket egyszer mutatjuk.
 */
export const customerDisplayName = (c: Pick<Customer, 'type' | 'companyName' | 'firstName' | 'lastName'>): string => {
  let name = c.type === 'organization'
    ? (c.companyName || '')
    : [c.lastName, c.firstName].filter(Boolean).join(' ');
  if (c.type !== 'organization' && c.lastName && c.lastName === c.firstName) {
    name = c.lastName;
  }
  const trimmed = name.trim();
  if (trimmed.length % 2 === 1) {
    const half = trimmed.slice(0, (trimmed.length - 1) / 2);
    if (half.length > 2 && trimmed === `${half} ${half}`) return half;
  }
  return trimmed;
};
